import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  SerahTerimaKantongDarah,
  SerahTerimaKantongListResponse
} from "@/types/serah_terima_kantong_darah";

function tolak(err: any) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

async function list(f: {
  tgl_start: string | null;
  tgl_end: string | null;
  term: string | null;
}): Promise<SerahTerimaKantongListResponse> {
  const res = await http
    .getDataParam("/serah-terima-kantong-darah", {
      params: {
        tgl_start: f.tgl_start || undefined,
        tgl_end: f.tgl_end || undefined,
        term: f.term || undefined
      }
    })
    .catch(tolak);
  return res.data.data;
}

async function simpan(form: SerahTerimaKantongDarah) {
  const res = form.id
    ? await http.putData(`/serah-terima-kantong-darah/${form.id}`, form).catch(tolak)
    : await http.postData("/serah-terima-kantong-darah", form).catch(tolak);
  return res.data;
}

async function destroy(id: number) {
  const res = await http.deleteData(`/serah-terima-kantong-darah/${id}`).catch(tolak);
  return res.data;
}

export default { list, simpan, destroy };
